/* eslint new-cap: ["error", { "capIsNew": false }]*/
import { RestAPI } from '@/util/net';
import { Map, fromJS } from 'immutable';

export const bugReportsLoaded = (state, action, type) =>
  state.set(type, fromJS(action.data));

export const bugReportsReducer = (state = Map(), action) => {
  switch (action.type) {
    case 'AUTO_BUGREPORT_LOADED':
      return bugReportsLoaded(state, action, 'auto');
    case 'USER_BUGREPORT_LOADED':
      return bugReportsLoaded(state, action, 'user');
    default:
      return state;
  }
};

export const loadAutoBugReportList = (dispatch) => {
  dispatch({ type: 'AUTO_BUGREPORT_LOADING' });
  return RestAPI
    .get('/bugreport/api/autolist')
    .then((data) => {
      dispatch({ type: 'AUTO_BUGREPORT_LOADED', data });
      return true;
    });
};

export const loadUserBugReportList = (dispatch) => {
  dispatch({ type: 'USER_BUGREPORT_LOADING' });
  return RestAPI
    .get('/bugreport/api/userlist')
    .then((data) => {
      dispatch({ type: 'USER_BUGREPORT_LOADED', data });
      return true;
    });
};
